(function($) {
  'use strict';

  var ProductSlider = {
    init: function() {
      this.initProductSliders();
      this.bindEvents();
    },

    initProductSliders: function() {
      var self = this;
      
      // Check if sliders exist
      if ($('.slider-for').length && $('.slider-nav').length) {
        self.initResponsiveSliders();
      }
    },

    initResponsiveSliders: function() {
      var config = {
        mediaQuerySmall: 'screen and (max-width: 749px)',
        mediaQueryMedium: '(min-width: 750px) and (max-width: 991px)',
        mediaQueryLarge: 'screen and (min-width: 992px)'
      };

      var mainSliderActive = false;
      var navSliderActive = false;

      // Main slider options (same for all breakpoints)
      var mainSliderOptions = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.slider-nav',
        dots: false,
        accessibility: true,
        touchThreshold: 20,
        adaptiveHeight: true
      };

      // Navigation slider options for different breakpoints
      var navSliderMobile = {
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        infinite: false,
        dots: false,
        arrows: false,
        focusOnSelect: true,
        vertical: false,
        accessibility: true,
        touchThreshold: 20,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      };

      var navSliderTablet = {
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        infinite: false,
        dots: false,
        arrows: false,
        focusOnSelect: true,
        vertical: false,
        accessibility: true,
        touchThreshold: 20
      };

      var navSliderDesktop = {
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        infinite: false,
        dots: false,
        arrows: false,
        focusOnSelect: true,
        vertical: false,
        accessibility: true,
        touchThreshold: 20
      };

      function initMainSlider() {
        if (mainSliderActive) {
          $('.slider-for').slick('unslick');
          mainSliderActive = false;
        }
        $('.slider-for').slick(mainSliderOptions);
        mainSliderActive = true;
      }

      function initNavSlider(options) {
        if (navSliderActive) {
          $('.slider-nav').slick('unslick');
          navSliderActive = false;
        }
        $('.slider-nav').slick(options);
        navSliderActive = true;
      }

      // Use enquire.js if available (like old theme)
      if (typeof enquire !== 'undefined') {
        enquire.register(config.mediaQuerySmall, {
          match: function() {
            initMainSlider();
            initNavSlider(navSliderMobile);
          }
        });

        enquire.register(config.mediaQueryMedium, {
          match: function() {
            initMainSlider();
            initNavSlider(navSliderTablet);
          }
        });

        enquire.register(config.mediaQueryLarge, {
          match: function() {
            initMainSlider();
            initNavSlider(navSliderDesktop);
          }
        });
      } else {
        // Fallback without enquire.js
        this.initWithoutEnquire(mainSliderOptions, navSliderDesktop);
      }
    },

    initWithoutEnquire: function(mainOptions, navOptions) {
      var self = this;
      
      function initSliders() {
        if ($(window).width() <= 749) {
          navOptions.slidesToShow = 3;
        } else if ($(window).width() <= 991) {
          navOptions.slidesToShow = 4;
        } else {
          navOptions.slidesToShow = 4;
        }

        $('.slider-for').slick(mainOptions);
        $('.slider-nav').slick(navOptions);
      }

      // Initialize on load
      initSliders();

      // Reinitialize on resize (debounced)
      var resizeTimer;
      $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          $('.slider-for, .slider-nav').slick('unslick');
          initSliders();
        }, 250);
      });
    },

    bindEvents: function() {
      // Custom events can be added here
      $(document).on('click', '.slider-nav .slick-slide', function() {
        var index = $(this).data('slick-index');
        $('.slider-for').slick('slickGoTo', index);
      });
    }
  };

  // Initialize when DOM is ready
  $(document).ready(function() {
    ProductSlider.init();
  });

})(jQuery);
